import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { Link, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { postLoginData } from "services/HomeService";
import { AxiosResponse } from "axios";
import { Controller, useForm } from "react-hook-form";
import Cookies from "js-cookie";

export interface PageLoginProps {
  className?: string;
}

interface LoginResponse {
  "AuthNet Profile Info ": any;
  "Customer Info ": any;
}
const PageLogin = ({ className = "" }) => {
  const MERCHANT_STORAGE_KEY = "merchantname";
  const [errorMessage, setErrorMessage] = useState("");
  const merchantname = Cookies.get(MERCHANT_STORAGE_KEY);
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const onSubmit = async (data: { email: string; password: string }) => {
   
     Cookies.remove("CustomerInfo")
     Cookies.remove("userDataaInfo");
     Cookies.remove('addedPayments')
     Cookies.remove('BillingAddress')
     Cookies.remove('checkTime')
     Cookies.remove('fromTime')
     Cookies.remove('toTime')
     Cookies.remove('user')
     Cookies.remove('SignupData')
     Cookies.remove('customerAdded')
     Cookies.remove('paymentId')
     Cookies.remove('loginTime')
     Cookies.remove('orderFee')
     Cookies.remove('paymentId')
     Cookies.remove('orderFeeLabel')
      Cookies.remove('phone')
     sessionStorage.removeItem("onlineOrderSettingsLogo");
    try {
      const LoginData = {
        email: data.email,
        password: data.password,
        schemaName: merchantname,
      };
      const response: AxiosResponse<LoginResponse, any> = await postLoginData(
        LoginData
      );
     
      Cookies.set(
        "CustomerInfo",
        JSON.stringify(response.data["Customer Info "])
      );
      Cookies.set(
        "userDataaInfo",
        JSON.stringify(response.data["AuthNet Profile Info "])
      );
       const authInfo = response.data["AuthNet Profile Info "];
      const paymentprofiles = authInfo?.paymentProfiles;
      Cookies.set("addedPayments", JSON.stringify(paymentprofiles));
      Cookies.set("user", JSON.stringify(authInfo?.customerProfileId));
      
      const loginTime = new Date().getTime();
      Cookies.set("loginTime", loginTime.toString());
      navigate(`/${merchantname}`);
      window.location.reload();
    } catch (error) {
      const ErrorResponse: any = error;
      setErrorMessage(ErrorResponse.response?.data?.message ?? "Login failed.");
    }
  };
  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>Basil POS Online Ordering</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Login
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          <div
            className={`${errorMessage &&"bg-red-100 border text-red-700 px-4 py-3 rounded relative"}`}
            role="alert"
          >
            <span className="block sm:inline">{errorMessage}</span>
          </div>
       
         
          <form
            className="grid grid-cols-1 gap-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
              <span className="text-red-500">*</span> 
                Email Address
              </span>
              <Controller
                name="email"
                control={control}
                rules={{
                  required: "Email is required",
                }}
                render={({ field }) => (
                  <Input
                    type="email"
                    placeholder="example@example.com"
                    className="mt-1"
                    {...field}
                  />
                )}
              />
              {errors.email && (
                <span className="text-red-500">{errors.email.message}</span>
              )}
            </label>
            <label className="block">
            <span className="text-neutral-800 dark:text-neutral-200">
              <span className="text-red-500">*</span>Password
              </span>
              <Controller
                name="password"
                control={control}
                rules={{ required: "password is required" }}
                render={({ field }) => (
                  <Input
                    type="password"
                    className="mt-1"
                    {...field}
                  />
                )}
              />
              {errors.password && (
                <span className="text-red-500">{errors.password.message}</span>
              )}
            </label>
            <ButtonPrimary type="submit">Continue</ButtonPrimary>
          </form>

          <span className="block text-center text-neutral-700 dark:text-neutral-300">
            New user? {` `}
            <Link className="text-green-600" to={`/${merchantname}/signup`}>
              Create an account
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PageLogin;
